import { useTimezone } from '@app/core/hooks/useTimezone';
import { DateRangeField, DecoratedFormUnit } from '@mi-front/ui';
import { Grid } from '@mui/material';
import moment from 'moment-timezone';
import { defineMessage, useIntl } from 'react-intl';

const dateRangeMessage = defineMessage({
  id: 'common.datetimeRange',
  defaultMessage: 'Rango de fecha y hora',
});

/**
 * Equal MD5 report filters: date range only (no time).
 */
export function EqualMd5ReportForm() {
  const { $t } = useIntl();
  const tz = useTimezone();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <DecoratedFormUnit label={$t(dateRangeMessage)}>
          <DateRangeField
            name={['from', 'to']}
            isOutsideRange={(date) => moment(date) > moment()}
            tz={tz}
          />
        </DecoratedFormUnit>
      </Grid>
    </Grid>
  );
}
